export default {
  getClientAttachment: (state) => state.clientAttachment,
};
